import { Form, FormInstance, List, Modal } from "antd";
import styles from "./style.module.scss";
import CloudFileUpload from "./CloudFileUpload";

interface EvaluateLabelPropagationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRunEvaluation: () => void;
  form: FormInstance;
}

const EvaluateLabelPropagationModal = ({
  isOpen,
  onClose,
  onRunEvaluation,
  form,
}: EvaluateLabelPropagationModalProps) => {
  const handleRunEvaluation = () => {
    onRunEvaluation();
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      title="Evaluate Label Propagation"
      width="50%"
      className={styles.modal}
      destroyOnHidden
      okText="Run Evaluation"
      okButtonProps={{
        form: `evaluate-label-propagation-form`,
        htmlType: "submit",
      }}
      cancelButtonProps={{ hidden: true }}
    >
      <div className={styles.modalBase}>
        <Form
          id={`evaluate-label-propagation-form`}
          form={form}
          layout="vertical"
          className={styles.applyDashBorder}
          onFinish={handleRunEvaluation}
        >
          <CloudFileUpload form={form} />

          <div className={styles.noteContainer}>
            <div className={styles.noteContent}>
              <div className={styles.noteHeader}>Note:</div>
              <List
                className={styles.noteList}
                size="small"
                dataSource={[
                  `File names must be exactly: DB.csv, Classes.json`,
                  `
                        Image path in DB.csv must contain the folder name
                        (before /images)`,
                ]}
                renderItem={(item) => (
                  <List.Item className={styles.noteListItem}>{item}</List.Item>
                )}
              />
            </div>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default EvaluateLabelPropagationModal;
